module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "agent-poor"
  }, [_c('div', {
    staticClass: "toolbar"
  }, [_c('el-button', {
    attrs: {
      "type": "success",
      "size": "small",
      "icon": "plus"
    },
    on: {
      "click": _vm.agentPoorReceive
    }
  }, [_vm._v("接收")]), _vm._v(" "), _c('div', {
    staticClass: "search-switch",
    style: (_vm.bgStyle)
  }, [_c('el-button', {
    staticClass: "search-btn",
    attrs: {
      "type": "info",
      "size": "small"
    },
    on: {
      "click": _vm.toggleSearch
    }
  }, [_vm._v("高级搜索\n                "), _c('i', {
    staticClass: "el-icon--right",
    class: _vm.arrowClass
  })])], 1)], 1), _vm._v(" "), _c('complex-search', {
    on: {
      "search": _vm.complexSearch,
      "reset": _vm.resetFilterData
    },
    model: {
      value: (_vm.searchVisiable),
      callback: function($$v) {
        _vm.searchVisiable = $$v
      },
      expression: "searchVisiable"
    }
  }), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "element-loading-text": "拼命加载中",
      "data": _vm.lists,
      "border": "",
      "highlight-current-row": ""
    },
    on: {
      "current-change": _vm.selectRow
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "index",
      "label": "序号",
      "width": "65"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "Customer",
      "label": "公司"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "C_Name",
      "label": "联系人"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "ProvincesName",
      "label": "省份"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "CityName",
      "label": "城市"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "AreaName",
      "label": "县市"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "EmployeeName",
      "label": "原所属业务经理"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "current-page": _vm.pageIndex,
      "page-sizes": _vm.pageSizes,
      "page-size": _vm.pageSize,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.totalSize * 1
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-995aa048!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/CRMagentPoor/index.vue
// module id = 1542
// module chunks = 1